import React, { useState } from "react";
import PropTypes from "prop-types";
import Input from "../common/Input";
import { STATUS } from "../common/Const";
import API from "../../services/UserService";

const shortPasswordMessage = "Hasło musi mieć co najmniej 8 znaków.";

const PasswordResetConfirm = ({ match, history }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [status, setStatus] = useState(STATUS.IDLE);

  const handleChange = (event) => {
    setPassword(event.target.value);
    if (event.target.value.length >= 8) {
      setError("");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setStatus(STATUS.SUBMITTING);

    if (password.length < 8) {
      setError(shortPasswordMessage);
      setStatus(STATUS.SUBMITTED);
      return;
    }

    API.confirmPasswordReset(match.params.token, password)
      .then((response) => {
        history.push("/manage", {
          passwordResetMessage: response && response.message ? response.message : "Hasło zostało zmienione.",
        });
      })
      .catch((apiError) => {
        setError(apiError.message || "Link resetujący jest nieprawidłowy albo wygasł.");
        setStatus(STATUS.SUBMITTED);
      });
  };

  return (
    <div className="quiz-text">
      <h2><strong>Ustaw nowe hasło</strong></h2>
      {error && <div className="alert alert-danger" role="alert">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="col-md-9 col-lg-7">
            <Input
              label="Nowe hasło"
              type="password"
              name="password"
              value={password}
              error={error}
              placeholder="Nowe hasło"
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 mb-2">
            <button type="submit" className="btn manage-button manage-red-button btn-block" disabled={status === STATUS.SUBMITTING}>Zmień hasło</button>
          </div>
        </div>
      </form>
    </div>
  );
};

PasswordResetConfirm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default PasswordResetConfirm;
